"use client";

import { Suspense } from "react";
import Link from "next/link";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import { BaseLink } from "./BaseLink";

export function CreditCardApplyLink({
  referralCode,
  label,
  ...props
}: {
  referralCode?: string;
  label: string;
} & ButtonProps) {
  return (
    <Suspense
      fallback={
        <Button
          asChild
          id="credit-card-page-header-apply-button"
          variant="theme"
          {...props}
        >
          <Link href="https://creditcard.exchange.gemini.com/credit-card/apply">
            {label}
          </Link>
        </Button>
      }
    >
      <BaseLink
        href="https://creditcard.exchange.gemini.com/credit-card/apply"
        id="credit-card-page-header-apply-button"
        label={label}
        referralCode={referralCode}
        {...props}
      />
    </Suspense>
  );
}
